import { render } from "./ownership.vue?vue&type=template&id=3a61d1bc&lang=pug"
import script from "./ownership.vue?vue&type=script&lang=js"
export * from "./ownership.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__